// ------------------
// Imports
// ------------------

import axios from 'axios';
import Config from '@/common/configs/api';
import Messages from '@/common/configs/messages';
import Store from '@/common/modules/store';



// ------------------
// Instance
// ------------------

const Axios = axios.create({
    baseURL: API_ORIGIN
});




// ------------------
// Interceptors
// ------------------

Axios.interceptors.response.use(undefined, error => {
    if (error.response && error.response.status === 401) {
        const config = error.response.config;
        if (config.refreshed) return Store.dispatch('session/destroy');

        return Store.dispatch('session/refresh')
            .then(token => Axios({
                ...config,
                refreshed: true,
                headers: {
                    ...config.headers,
                    Authorization: 'Bearer ' + token
                }
            }));
    }
    return Promise.reject(error.message);
});

Axios.interceptors.response.use(undefined, error => {
    if (axios.isCancel(error)) return Promise.race([]);
    Store.dispatch('toasts/error', error.message || Messages.serverError);
    return Promise.reject(error.message);
});



// ------------------
// Helpers
// ------------------

let cancellers = [];

function abort (canceller) {
    const index = cancellers.indexOf(canceller);
    if (index === -1) return;
    cancellers[index].cancel();
    cancellers.splice(index, 1);
}



// ------------------
// Exports
// ------------------

function API (...args) {

    const key = args.shift();

    if (!Config[key]) {
        return Promise.reject(new Error(`API('${key}') is not configured`));
    }

    let config = Config[key].apply(null, args);
    let canceller;

    if (!config.continues) {
        canceller = axios.CancelToken.source();
        config.cancelToken = canceller.token;
        cancellers.push(canceller);
    }

    config.headers = {
        Authorization: 'Bearer ' + Store.state.session.token.jwt,
        ...config.headers
    };

    let request = Axios(config);
    request.canceller = canceller;

    const cb = abort.bind(null, canceller);
    request.then(cb).catch(cb);

    return request;
}


API.abort = function (request) {
    if (request) abort(request.canceller);
    else cancellers.forEach(abort);
};


export default API;
